import { render, staticRenderFns } from "./Resister.vue?vue&type=template&id=c87f706a&scoped=true"
import script from "./Resister.vue?vue&type=script&lang=js"
export * from "./Resister.vue?vue&type=script&lang=js"
import style0 from "./Resister.vue?vue&type=style&index=0&id=c87f706a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87f706a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c87f706a')) {
      api.createRecord('c87f706a', component.options)
    } else {
      api.reload('c87f706a', component.options)
    }
    module.hot.accept("./Resister.vue?vue&type=template&id=c87f706a&scoped=true", function () {
      api.rerender('c87f706a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cas/Resister.vue"
export default component.exports